import React from 'react';
import { DataCard } from '../../../components';
import * as S from './styled';

const LoaderPage = () => {
  return (
    <S.Wrapper>
      <DataCard loading={true}>
      </DataCard>
    </S.Wrapper>
  );
};

export default LoaderPage;
